/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Milestone_PillInputs */

const en_us2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

const pt_br2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const es_419_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro`)
};

const pt_pt2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const fr_fr2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cap`)
};

const de_de2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

const it_it2_share_milestone_pill = /** @type {(inputs: Share_Milestone_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traguardo`)
};

/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Share_Milestone_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_milestone_pill = /** @type {((inputs?: Share_Milestone_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Milestone_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_milestone_pill(inputs)
	if (locale === "es-419") return es_419_share_milestone_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_share_milestone_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_share_milestone_pill(inputs)
	if (locale === "de-DE") return de_de2_share_milestone_pill(inputs)
	if (locale === "it-IT") return it_it2_share_milestone_pill(inputs)
	return en_us2_share_milestone_pill(inputs)
});
export { share_milestone_pill as "share.milestone_pill" }